import React from 'react'

const Manual_editar_gift_card = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Editar Gift Card para Google y Apple Wallet
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Conoce el proceso para modificar los diseños y datos de tus Gift Cards en Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Editar_Gift_Card_para_Google_y_Apple_Wallet__cxVF9E44RfSaDT0AE8k6xw?as=scrollable"
          className="scribe-iframe-general-97"
          width="100%"
          height="12800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_editar_gift_card
